import { version } from '../../package.json';
import { PFUSCHBET_BRAND } from '../app/branding/pfuschbet.brand';

export const environment = {
  production: false,
  apiUrl: 'https://devb2d.vitory.info',
  api2Url: 'https://api.vitory.com:85',
  registrationUrl: 'https://anmelden.vitory.com',
  version: version,
  brand: { ...PFUSCHBET_BRAND, title: 'PfuschBet (Staging)' }
};
